import axios from 'axios';

const api = axios.create({ baseURL: '/api', timeout: 30000 });

// Der Store registriert diese Handler beim Laden. Umgekehrt würde api.js den
// Store importieren, der api.js importiert - ein Ringschluss.
let handlers = {
  getRefreshToken: () => null,
  onRefreshed: () => {},
  onFailure: () => {},
};

export const setAuthHandlers = (neue) => {
  handlers = { ...handlers, ...neue };
};

api.interceptors.request.use((config) => {
  const stored = localStorage.getItem('praenatal-auth');
  if (stored) {
    const { state } = JSON.parse(stored);
    if (state?.accessToken) config.headers.Authorization = `Bearer ${state.accessToken}`;
  }
  return config;
});

// Nur ein Refresh-Lauf gleichzeitig. Ohne das würden mehrere parallel
// aufgelaufene 401er mehrere Läufe starten, und weil jeder Lauf das Token
// rotiert, würden sich die Läufe gegenseitig entwerten.
let refreshLauf = null;

const holeNeueTokens = () => {
  if (!refreshLauf) {
    const refreshToken = handlers.getRefreshToken();
    refreshLauf = axios
      .post('/api/auth/refresh', { refreshToken })
      .then(({ data }) => {
        handlers.onRefreshed(data);
        return data;
      })
      .catch((err) => {
        handlers.onFailure();
        throw err;
      })
      .finally(() => {
        refreshLauf = null;
      });
  }
  return refreshLauf;
};

api.interceptors.response.use(
  (antwort) => antwort,
  async (fehler) => {
    const { response, config } = fehler;
    if (!response || response.status !== 401 || !config || config._wiederholt) {
      throw fehler;
    }
    // Ein 401 beim Anmelden oder beim Refresh selbst ist keine abgelaufene
    // Sitzung, sondern das Ergebnis - hier darf nicht nachgefasst werden.
    if (config.url?.includes('/auth/login') || config.url?.includes('/auth/refresh')) {
      throw fehler;
    }
    if (!handlers.getRefreshToken()) {
      handlers.onFailure();
      throw fehler;
    }

    await holeNeueTokens();
    config._wiederholt = true;
    return api(config);
  }
);

export default api;
